import footerLogo from "./logo-footer.png";

function Footer() {
  return (
    <footer className="footer" id="footer">
      <div className="footer__contents">
        <div className="logo">
          <img src={footerLogo} alt="company logo"></img>
        </div>

        <div className="copyrights">
          <p>© 2020 Kasa. All rights reserved</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
